"use client"

import { useState, useEffect } from "react"
import { Send, X } from "lucide-react"
import { cn } from "@/lib/utils"
import { telegramUrl } from "@/data/ru-it-support/config"

/** Schwebender Telegram-Button für die russischen Seiten (Pendant zum WhatsApp-Button). */
export function TelegramButton() {
    const [isVisible, setIsVisible] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 2000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <div
            className={cn(
                "fixed bottom-4 left-4 z-50 flex flex-col items-start gap-3 transition-all duration-500",
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"
            )}
        >
            <div
                className={cn(
                    "overflow-hidden transition-all duration-300",
                    isExpanded ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                )}
            >
                <div className="rounded-2xl rounded-bl-sm bg-background border shadow-xl p-4 max-w-[260px]">
                    <p className="text-sm font-medium mb-1">Есть вопрос?</p>
                    <p className="text-xs text-muted-foreground mb-3">
                        Напишите мне в Telegram — отвечу, как только смогу.
                    </p>
                    <a
                        href={telegramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 rounded-full bg-[#229ED9] px-4 py-2 text-sm font-medium text-white hover:bg-[#1E8BC3] transition-colors shadow-sm"
                    >
                        <Send className="h-4 w-4" />
                        Написать в Telegram
                    </a>
                </div>
            </div>

            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className={cn(
                    "flex items-center justify-center h-14 w-14 rounded-full shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105",
                    isExpanded
                        ? "bg-muted text-foreground border"
                        : "bg-[#229ED9] text-white hover:bg-[#1E8BC3]"
                )}
                aria-label={isExpanded ? "Закрыть меню Telegram" : "Открыть Telegram"}
            >
                {isExpanded ? (
                    <X className="h-6 w-6" />
                ) : (
                    <Send className="h-6 w-6" />
                )}
            </button>
        </div>
    )
}
